import React, { useRef, useEffect } from 'react';
import { gsap } from 'gsap';
import Button from '../../general/Button/Button';  // Importa seu botão customizado
import './CardTool.css';

const CardTool = ({ toolName, description, url }) => {
  const cardRef = useRef(null);
  const isDisabled = !toolName || !description;

  useEffect(() => {
    gsap.set(cardRef.current, { opacity: 0, scale: 0.9 });
    gsap.to(cardRef.current, { opacity: 1, scale: 1, duration: 0.5, ease: 'power2.out' });
  }, []);

  const handleMouseEnter = () => {
    gsap.to(cardRef.current, { scale: 1.05, duration: 0.3, ease: 'power2.out' });
  };

  const handleMouseLeave = () => {
    gsap.to(cardRef.current, { scale: 1, duration: 0.3, ease: 'power2.out' });
  };

  return (
    <div
      ref={cardRef}
      className={`card-tool-card ${isDisabled ? 'disabled' : ''}`}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div className="card-tool-body">
        <div className="card-tool-header">
          <strong className="card-tool-title">{toolName}</strong>
          {url ? (
            <a href={url} target="_blank" rel="noopener noreferrer">
              <Button variant="primary" className="btn-link" disabled={isDisabled}>
                Usar
              </Button>
            </a>
          ) : (
            <Button variant="primary" className="btn-link" disabled={isDisabled}>
              Usar
            </Button>
          )}
        </div>
        <p className="card-tool-description">{description}</p>
      </div>
    </div>
  );
};

export default CardTool;
